import { Injectable } from '@angular/core';
declare var jquery: any;
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class NiceScrollService {

  constructor() { }

  scrollToDiv(id: string) {
    document.querySelector(id).scrollIntoView({
      behavior: 'smooth'
    });
  }

  scrollToTop() {
      // tslint:disable-next-line: only-arrow-functions
      const scrollToTop = window.setInterval(function() {
        // tslint:disable-next-line: prefer-const
        let pos = window.pageYOffset;
        if (pos > 0) {
            window.scrollTo(0, pos - pos); // how far to scroll on each step
        } else {
            window.clearInterval(scrollToTop);
        }
    }, 10); // how fast to scroll (this equals roughly 60 fps)
  }

}
